export default __webpack_public_path__ + "static/media/Twitter2.0deafa31.svg";